<template>
  <div>
  pthprishtine kontakti</div>
</template>

<script>
export default {

}
</script>

<style>

</style>